<template>
  <b-card>
    <b-form @submit="addTree">
      <b-row>
        <b-col sm="12">
          <b-form-group label="name *" label-for="name">
            <b-form-input id="name" v-model="form.name" required />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <b-form-group label="type" label-for="type">
            <v-select
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="options"
            v-model="form.type"
            />
          </b-form-group>
        </b-col>

        <b-col sm="12" v-if="form.type == 'child'">
          <b-form-group label="id_parent" label-for="id_parent">
            <b-form-input id="id_parent" v-model="form.id_parent" />
          </b-form-group>
        </b-col>

        <b-col sm="12">
          <div class="mb-1">
            Image
          </div>
          <div id="dropzone-news-image" class="dropzone dropzone-area mb-3">
            <div class="dz-message">
              Drop files here or click button to upload. <br />(Max. size 2MB)
            </div>
          </div>
        </b-col>

        <b-col class="d-flex justify-content-end">
          <b-button type="button" class="mr-1" variant="light">
            Cancel
          </b-button>
          <b-button type="submit" :disabled="isLoading" variant="primary">
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BCard,
  BFormInput,
  BButton,
  BForm,
  BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BCard,
    BFormInput,
    BButton,
    BForm,
    BFormCheckbox,
    vSelect,
  },

  data() {
    return {
      isLoading: false,
      snowOption: {
        theme: 'snow',
      },
      dzInstance: null,
      form: {
        name: null,
        image: null,
        type: null,
        id_parent: null,
      },
      options: ['child','parent']
    }
  },

  mounted() {
    this.initDropzone()
  },

  destroyed() {
    this.dzInstance.disable()
  },

  methods: {
    initDropzone() {
      const options = {
        url: `${process.env.VUE_APP_API_HOST}/api/tree-admin/uploadImage`,
        maxFiles: 1,
        autoProcessQueue: true,
        autoQueue: true,
        addRemoveLinks: true,
        acceptedFiles: 'image/jpeg,image/jpg,image/png',
        headers: {
          Authorization: `Bearer ${this.$store.getters['oauth/getToken']}`,
        },
      }
      const { drawLogoImage, deleteTempFile } = this

      this.dzInstance = new window.Dropzone('#dropzone-news-image', {
        ...options,
        init() {
          this.on('success', (file, res) => drawLogoImage(res.data))
          this.on('removedfile', () => deleteTempFile())
        },
      })
    },

    drawLogoImage(imagePath) {
      this.form.image = imagePath
    },

    deleteTempFile() {
      const deleteFileTempUrl = '/tree-admin/deleteImage'

      this.$http
        .post(deleteFileTempUrl, {
          path: this.form.image,
        })
        .then(() => {
          this.form.image = ''
        })
    },

    addTree(event) {
      event.preventDefault()
      this.isLoading = true

      this.$http
        .post('/tree-admin/store', {
          ...this.form,
        })
        .then(() => {
          this.$notif('Success', 'Tree has been successfully added.', 'success')
          this.$router.push({ name: 'admin-tree' })
        })
        .catch(({ data }) => {
          this.$notif('Error', `${data}`, 'error')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
